import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    background: '#FFFFFF',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.12), 0px 0px 0px 1px rgba(19,45,74,0.04)',
    borderRadius: '8px',
    padding: '8px 24px',
    display: 'grid',

    gridTemplateColumns: '1fr 1fr 56px',
    justifyContent: 'space-between',
    width: '100%',
    gap: 36,
    alignItems: 'center',
    marginBottom: 8,
    [theme.breakpoints.down(1320)]: {
      gridTemplateColumns: '0.4fr 1fr 56px',
    },
  },
  warning: {
    width: 24,
    height: 'auto',
  },
  done: {
    width: 24,
    height: 'auto',
    color: theme.palette.success.main,
  },
  selectContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '24px 1fr',
    alignItems: 'center',
    gap: 8,
  },
  select: {
    maxWidth: '100%',
    width: '376px',
    '& .MuiSelect-root': {
      paddingTop: 10,
      paddingBottom: 10,
    },
    '& .MuiListItemText-root': {
      marginTop: 0,
      marginBottom: 0,
      '& .MuiTypography-body1': {
        lineHeight: 'initial',
      },
    },
    [theme.breakpoints.down(1320)]: {
      width: '100%',
    },
  },
  fileName: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  actionContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '24px 1fr',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
  },
  actionInner: {
    padding: 8,
  },
  actionIcon: {
    width: 24,
    height: 'auto',
    color: theme.palette.primary.dark,
  },
}))

export default useStyles
